'use client'

import theme from '@/src/config/theme'

import {LoadingPage} from '@/src/shared/ui/layout/ui/loading-page'

export const AsyncProcessLoading = () => {
  return <LoadingPage background={theme.colors.darkTransparent} />
}
